import React from 'react'
import { StyledRange } from 'components/DatePickerStyles/DatePickerStyles'
import SeperatorIcon from 'components/icons/SeperatorIcon'
import CalendarIcon from 'components/icons/CalendarIcon'
import Label from 'components/Form/Label'
import moment from 'moment'


const DateFilter = ({ setDateFilter}) => {

  const onDateChange = (value,dates) => {

    setDateFilter({ startDate: moment(dates[0], 'DD/MM/YYYY').format('YYYY-MM-DD'), endDate: moment(dates[1], 'DD/MM/YYYY').format('YYYY-MM-DD') })
  }

  const dateFormat = 'DD/MM/YYYY';

  return (
    <>
      <Label>
        Date
      </Label>
        <StyledRange
          width="100%"
          format={dateFormat}
          placeholder={['DD/MM/YYYY', 'DD/MM/YYYY']}
          separator={<SeperatorIcon />}
          suffixIcon={<CalendarIcon />}
          onChange={onDateChange}
          allowClear={true}
        />
    </>
  )
}

export default DateFilter
